export default {
  assets: {
    asset: "Asset",
    assets: "Assets",
    assetLevel: "Asset Level",
    assetModel: "Model",
    models: "Models",
    model: "Model",
    assetType: "Type",
    assetTypes: "Types",
    provider: "Provider",
    serialNo: "Serial No.",
    tags: "Tags",
    user: "user",
    itemManufacturer: "Manufacturer",
    manufacturerName: "Manufacturer Name",
    manufacturerCode: "Manufacturer Code",
    associatedModels: "Associated Models",
    associatedAssets: "Associated Assets",
    projectName: "Project Name",
    commissioningDate: "Commissioning",
    constructionDate: "Construction",
    assetId: "Asset Id",
    AssetLocalization: "Asset localization ",
    identifier: "Identifier",
    createOrSelectTags: "select tags",
    createNewAssetTag: "Create new asset tag",
    errorAssetTag: "Tag already exists",
    noAssets: "No assets",
  },
  user: {
    name: "User",
    plural: "Users",
    columns: {
      id: "ID",
      userName: "User",
      contact: "Contact",
      myProfile: "My Profile",
      contactList: "Contact List",
      tenant: "Tenant",
      roles: "Roles",
      registrationDate: "Registration Date",
      firstName: "First Name",
      lastName: "Last Name",
      status: "status",
      approved: "Approved",
      pending: "Pending",
      authenticationProvider: "Authentication Provider",
      email: "Email",
      language: "Language",
      userDescription: "User Description",
      lastLogin: "Last Login",
      createdAt: "Created on",
      modifiedAt: "Modified on",
      isDeleted: "is deleted",
      displayName: "Display Name",
      declined: "Declined",
    },
  },
  tenant: {
    name: "Tenant",
    plural: "Tenants",
    myTenants: "My Tenant",
    phone: "Phone number",
    zipCode: "Postal Code",
    country: "Country",
    city: "City",
    streetAndNumber: "Street and number",
    backToTenants: "Back to Tenants",
    tenantIfo: "Tenant Information",
    amountOfUsers: "Amount of Users",
    amountOfAssets: "Amount of Assets",
    amountOfBillingAddress: "Amount of Billing Addresses",
    amountOfContact: "Amount of Contacts",
    columns: {
      id: "ID",
      tenantIdentifier: "Tenant ID",
      tenantName: "Tenant Name",
      isDeleted: "is deleted",
      createdAt: "Created on",
      modifiedAt: "Modified on",
      tenantRole: "Tenant Role",
      tenantType: "Tenant Type",
    },
  },
  role: {
    name: "Role",
    plural: "Roles",
    tenantRole: {
      "2ab640dd-39c0-4dc5-9a3f-1919f8efd4d0": "Plant Operator",
      "6413f36a-0dd6-42a5-a3ac-a99f4539f48e": "Rescue Service",
      "f8aa95db-158e-4a9e-8a0f-b5dcbcc5b1b7": "Platform Operator",
      "8c5e7fda-e8bf-4a96-9a85-a6e23a8cd635": "Service Company",
    },
    columns: {
      id: "ID",
      name: "Name",
      description: "Description",
      isDefaultRole: "is default role",
      createdAt: "Created on",
      modifiedAt: "Modified on",
      isDeleted: "is deleted",
    },
  },
};
